// Public UI adapted from Klargo-Reference/components/ds/useDsBreakpoints.ts.
import { useEffect, useState } from 'react';
const read = () => {
    if (typeof window === 'undefined') {
        return { isMobile: false, isFactsNarrow: false, isNarrow: false, isRegistryNarrow: false };
    }
    const width = window.innerWidth;
    return {
        isMobile: width <= 760,
        isFactsNarrow: width <= 767,
        isNarrow: width <= 980,
        isRegistryNarrow: width <= 1140,
    };
};
export function useDsBreakpoints() {
    const [state, setState] = useState(read);
    useEffect(() => {
        const sync = () => {
            const next = read();
            setState((current) => current.isMobile === next.isMobile &&
                current.isFactsNarrow === next.isFactsNarrow &&
                current.isNarrow === next.isNarrow &&
                current.isRegistryNarrow === next.isRegistryNarrow
                ? current
                : next);
        };
        sync();
        window.addEventListener('resize', sync);
        window.addEventListener('orientationchange', sync);
        let observer;
        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(sync);
            observer.observe(document.documentElement);
        }
        return () => {
            window.removeEventListener('resize', sync);
            window.removeEventListener('orientationchange', sync);
            observer?.disconnect();
        };
    }, []);
    return state;
}
